angular.module('rjmNg.directives').directive "routeTitle", [
  () ->
    bindToController: true
    controllerAs: 'view'
    restrict: "A"
    replace: true
    scope: {}
    template: "<title ng-bind='view.pageTitle'></title>"
    controller: [
      "$scope"
      "$route"
      ($scope,$route) ->

        view = @

        view.pageTitle = "Adobe Commerce Intelligence"

        #assign the page title on route change if pageTitle is assigned to that route
        $scope.$on "$routeChangeSuccess", (e, cur, prev) ->
          if $route.current.pageTitle?
            view.pageTitle = "Adobe Commerce Intelligence - #{$route.current.pageTitle}"

        $scope.$on 'setWindowTitle', (event, args) ->
          view.pageTitle = args.title

        view
    ]
  ]
